<template>
  <!-- :cpntFundoFechar="false" -->
  <!-- :cpntOcultarBotoes="true" -->
  <RF-Dialog
    :cpntStatus='statusGeral'
    :cpntLargura='"660px"'
    :cpntTitulo="[ '', null, undefined ].indexOf(pagina) === -1 ? '' : null"

    :cpntOnFecharDialog='pacVenFechar'>
    <template slot='titulo' v-if="[ '', null, undefined ].indexOf(pagina) === -1">
      <svg aria-hidden="true" class="fa fa-angle-double-right"></svg>
      Decisão Pacote
      <!-- <table class="aba-titulo">
        <tr>
          <td class="passadores">
            <span v-if="pagina >= 1" @click="pacVenAlterarPagina('pac-ven-decisao-pag-passador--voltar')">
              <i class="far fa-arrow-alt-circle-left" title="Voltar"></i>
            </span>
            <span v-else-if="pagina === 'fim'" @click="pacVenAlterarPagina('pac-ven-decisao-pag-passador--voltar')">
              <i class="far fa-arrow-alt-circle-left" title="Voltar"></i>
            </span>
          </td>
          <td>
            <template v-if="[ '', null, undefined, 'fim' ].indexOf(pagina) === -1 && [ '', null, undefined ].indexOf(contratar[pagina]) === -1 && [ '', null, undefined ].indexOf(contratar[pagina].faltam_n_dias) === -1">
              <template v-if="contratar[pagina].faltam_n_dias >= 1">
                Você ainda tem {{ contratar[pagina].faltam_n_dias }} dia{{ contratar[pagina].faltam_n_dias >= 2 ? 's' : '' }} para testar este pacote.
              </template>
              <template v-else-if="contratar[pagina].faltam_n_dias <= 0">
                Prazo de teste expirado em {{ contratar[pagina].dt_vencimento }}
              </template>
            </template>
            <template v-else-if="[ 'fim' ].indexOf(pagina) !== -1">
              Digite sua senha para efetivar esta operação.
            </template>
          </td>
          <td class="passadores">
            <span v-if="pagina !== 'fim'" @click="pacVenAlterarPagina('pac-ven-decisao-pag-passador--proxima')">
              <i  class="far fa-arrow-alt-circle-right" title="Próxima"></i>
            </span>
          </td>
        </tr>
      </table> -->
    </template>

    <template slot='conteudo'>
      <div style="padding-top: 10px;">
        <div class="pac-vencidos">

          <!-- <div class="pagina-pacotes" v-else-if="[ '', null, undefined ].indexOf(pagina) === -1 && [ '', null, undefined ].indexOf(contratar[pagina]) === -1"> -->
          <div class="pagina-pacotes" v-for="(item, indexP) in contratar" :key="'pac--' + indexP">
            <table>
              <tr>
                <td class="dados">
                  <!-- ({{ item }}) -->
                  <div class="titulo">
                    <i class="fas fa-arrow-right"></i>
                    <span v-html="item.pac_nome"></span>
                    <hr/>
                  </div>

                  <br/>
                  <App-Button style="margin-top: 10px;" v-if="contratar[indexP]._detalhe === false" @onClick="() => { pacVenAlterarDetalhe(indexP) }">Mostrar Detalhes</App-Button>
                  <template v-else>
                    <App-Button style="margin-top: 10px;" @onClick="() => { pacVenAlterarDetalhe(indexP) }">Ocultar Detalhes</App-Button>
                    <ul :key="'detalhe--' +indexP + '--' + contratar[indexP]._detalhe">
                      <li v-for="(desc, indexD) in item._j_pac_desc" :key="'pac-ven-desc-' + indexD">
                        <span v-html="desc"></span>
                      </li>
                    </ul>
                  </template>
                </td>
                <td class="buttons">
                  <div class="valores">
                    <template v-if="item.pac_id === '30'">
                      <span>R$ </span>
                      <span v-html="item._lu_valor" class="valor"></span>
                      <span>/GB/mês</span>
                    </template>
                    <!-- <template v-else-if="item.pac_id === '36'">
                      <span>R$ </span>
                      <span v-html="item._lu_valor" class="valor"></span>
                      <span>/CNPJ Adicional/mês</span>
                    </template> -->
                    <template v-else-if="item.pac_id === '37'">
                      <span>R$ </span>
                      <span v-html="item._lu_valor" class="valor"></span>
                      <span>/CLU Adicional/mês</span>
                    </template>
                    <template v-else>
                      <span>R$ </span>
                      <span v-html="item._lu_valor" class="valor"></span>
                      <span>/mês</span>
                    </template>

                    <div style="font-size: 10px;" v-if="[ 16, '16' ].indexOf(item.pac_id) !== -1">Além deste valor, requer um usuário adicional.</div>

                    <div style="font-size: 10px;" v-if="[ '', null, undefined ].indexOf(item.bilhetagem_valor) === -1 && Number(item.bilhetagem_valor) >= 1">+ R$ {{ item._bilhetagem_valor  }} por evento <span v-if="Number(item.lu_incluso) > 0"><br/>(incluso {{ item.lu_incluso }})</span></div>

                    <div style="font-size: 13px; margin-top: 10px;" v-else-if="[ 36, '36' ].indexOf(item.pac_id) !== -1">+ R$ {{ dados._valor_cnpj_adicional  }} / mês por CNPJ adicional</div>

                    <div style="font-size: 13px; margin-top: 10px;" v-else-if="[ 37, '37' ].indexOf(item.pac_id) !== -1">+ R$ {{ dados._valor_sin_clu_adicional }} / mês por CLU Sincronizada</div>

                    <div style="font-size: 13px; margin-top: 10px;" v-if="[ '', null, undefined ].indexOf(item.ti_valor) === -1 && Number(item.ti_valor) >= 1">
                      <!-- <template v-if="[ '', null, undefined ].indexOf(item.ti_desc) === -1">
                        <span v-html="item.ti_desc"></span>
                      </template> -->
                      <!-- <template v-else> -->
                      <template>
                        Taxa Inscrição:<br/>R$ <span v-html="item._ti_valor" class="valor"></span>
                      </template>
                    </div>
                  </div>

                  <div>
                    <RF-Button 
                      :data-time="time"
                      :cpntId='"pac-ven-decisao-resposta--" + pagina + "--s"'
                      :cpntStatus='""' 
                      :cpntTexto='"Contratar"' 
                      :cpntClass="item.decisao === 's' ? [ 'btn', 'btn-success' ] : [ 'btn', 'btn-default', 'btn-sm' ]"

                      @onClickButton='(id) => { pacVenResponderPergunta(id, indexP) }'
                    ></RF-Button>  
                    <br/>
                    <RF-Button 
                      :data-time="time"
                      :cpntId='"pac-ven-decisao-resposta--" + pagina + "--n"'
                      :cpntStatus='""' 
                      :cpntTexto='"Não"' 
                      :cpntClass="item.decisao === 'n' ? [ 'btn', 'btn-danger' ] : [ 'btn', 'btn-default', 'btn-sm' ]"

                      @onClickButton='(id) => { pacVenResponderPergunta(id, indexP) }'
                    ></RF-Button>

                    <div v-if="item.pode_adiar === 's'" class="adiar">
                      <a @click="pacVenResponderPergunta('pac-ven-decisao-resposta--' + pagina + '--a', indexP)">Ver depois</a>
                    </div>
                  </div>
                </td>
              </tr>
            </table>

          </div>

          
          <div class="pagina-fim">
            <!-- <div class="fatura">
              <table>
                <template v-for="(pacote, indexP) in contratar">
                  <tr class="valores" :key="'pac-ven-fim-' + indexP" v-if="pacote.decisao !== 'a'">
                    <td>
                      <span v-html="pacote.pac_nome + ': '"></span>
                    </td>
                    <td>
                      <template v-if="pacote.decisao === 's'">
                        <!- <template v-if="pacote.pac_id === '30'">
                          <span>R$ </span>
                          <span v-html="pacote._lu_valor" class="valor"></span>
                          <span>/GB/Mês</span>
                        </template> --
                        <!- <template v-else-if="pacote.pac_id === '37'">
                          <span>R$ </span>
                          <span v-html="pacote._lu_valor" class="valor"></span>
                          <span>/CLU Adicional/Mês</span>
                        </template> --
                        <!- <template v-else>
                          <span>+ R$ </span>
                          <span v-html="pacote._lu_valor"></span>
                        </template> --
                        <span>+ R$ </span>
                        <span v-html="pacote._lu_valor"></span>
                      </template>
                      <span v-else-if="pacote.decisao === 'n'">Não contratar</span>
                    </td>
                  </tr>
                </template>
                <tr>
                  <td colspan="2">
                    <hr/>
                  </td>
                </tr>
                <tr class="valores" v-if="[ '', null, undefined ].indexOf(valores._total) === -1">
                  <td>
                    Adicional total:
                  </td>
                  <td>
                    <template v-if="valores._total !== '---'">
                      <span>R$ </span>
                    </template>
                    <span v-html="valores._total"></span>
                  </td>
                </tr>
                <tr class="valores" v-if="[ '', null, undefined, 0, '0', '0,0', '0,00' ].indexOf(valores._ti_valor) === -1">
                  <td>
                    Taxa Inscrição:
                  </td>
                  <td>
                    <template v-if="valores._ti_valor !== '---'">
                      <span>R$ </span>
                    </template>
                    <span v-html="valores._ti_valor"></span>
                  </td>
                </tr>
              </table>
            </div> -->

            <div class="fatura-info" style="text-align: center;">
              <div class="descricao" style="text-align: center;">
                <template v-if="contratar.filter(item => item.decisao === 's').length >= 1">
                  * Pacotes adicionados só poderão ser removidos após 30 dias.
                  <br/>
                  <br/>
                </template>
                <template v-if="contratar.filter(item => item.decisao === 'n').length >= 1">
                  * Pacotes removidos só poderão ser testados novamente daqui a 10 dias.
                  <br/>
                  <br/>
                </template>
                Informe a senha do seu usuário [ <b v-html="$store.state.token.conta"></b> ].
              </div>

              <div class="campos">
                <RF-Componente
                  :data-time='time'
                  :cpntTamanho='senha.tamanho'
                  :cpntModelo='senha.tipo'
                  :cpntType='senha.type'
                  :cpntStatus='senha.status'
                  :cpntId='senha.id'
                  :cpntClassDivField='senha.classDivField'
                  :cpntNome='senha.nome'
                  :cpntValue='senha.value'
                  :cpntValueRef='senha.valueRef'
                  :cpntOptions='senha.options'
                  :cpntKeyValue='senha.keyValue'
                  :cpntKeyMostra='senha.keyMostra'
                  :cpntAutoComplete='senha.autocomplete'
                  :cpntDisabled='senha.disabled'
                  :cpntMostrar='senha.mostrar'
                  :cpntMensagem='senha.mensagem'
                  :cpntSelecioneNome='senha.selecioneNome'
                  :cpntSelecioneValue='senha.selecioneValue'
                  :cpntMensagemTipo='senha.mensagemTipo'
                  :cpntAdicinarOption='senha.adicinarOption'
                  :cpntMultiple='senha.multiple'
                  :cpntAllRegistro='senha.allRegistro'
                  :cpntExplica='senha.explica'
                  :cpntConfig='senha.config'
                  :cpntTabIndex='senha.tabIndex'
                  :cpntMaxLength='senha.maxLength'
                  :cpntOptionInicialNome='senha.optionInicialNome'
                  :cpntOptionInicialValue='senha.optionInicialValue'

                  :cpntOnChange='senha.onChange'
                  :cpntOnBlur='senha.onBlur'
                  :ref='senha.id'
                ></RF-Componente>

                <RF-Button v-if="Object.keys(confirma).length >= 1"
                  :data-time="time"
                  :cpntId='confirma.id'
                  :cpntStatus='confirma.status' 
                  :cpntTexto='confirma.texto' 
                  :cpntClass="confirma.class"

                  @onClickButton='confirma.onClick'
                ></RF-Button>
              </div>
            </div>
          </div>
        </div>

        <RF-Dialog v-if="Object.keys(motivo).length >= 1"
          :cpntStatus='motivo.status'
          :cpntLargura='"510px"'
          :cpntAnimacao='true'

          :cpntOnFecharDialog='pacVenSalvarMotivo'>
          <template slot='titulo'>
            <i aria-hidden="true" class="fa fa-angle-double-right"></i>
            Nos ajude a melhorar!
          </template>

          <template slot='conteudo'>
            <div style="margin-top: 20px;">
              <RF-Componente
                :data-time='time'
                :cpntTamanho='motivo.tamanho'
                :cpntModelo='motivo.tipo'
                :cpntStatus='motivo.status'
                :cpntId='motivo.id'
                :cpntClassDivField='motivo.classDivField'
                :cpntNome='motivo.nome'
                :cpntValue='motivo.value'
                :cpntValueRef='motivo.valueRef'
                :cpntOptions='motivo.options'
                :cpntKeyValue='motivo.keyValue'
                :cpntKeyMostra='motivo.keyMostra'
                :cpntAutoComplete='motivo.autocomplete'
                :cpntDisabled='motivo.disabled'
                :cpntMostrar='motivo.mostrar'
                :cpntMensagem='motivo.mensagem'
                :cpntSelecioneNome='motivo.selecioneNome'
                :cpntSelecioneValue='motivo.selecioneValue'
                :cpntMensagemTipo='motivo.mensagemTipo'
                :cpntAdicinarOption='motivo.adicinarOption'
                :cpntMultiple='motivo.multiple'
                :cpntAllRegistro='motivo.allRegistro'
                :cpntExplica='motivo.explica'
                :cpntConfig='motivo.config'
                :cpntTabIndex='motivo.tabIndex'
                :cpntMaxLength='motivo.maxLength'
                :cpntOptionInicialNome='motivo.optionInicialNome'
                :cpntOptionInicialValue='motivo.optionInicialValue'

                :cpntOnChange='motivo.onChange'
                :cpntOnBlur='motivo.onBlur'
                :ref='motivo.id'
              ></RF-Componente>

              <div style="text-align: center; margin: 20px 0px 0px 0px;">
                <RF-Button 
                  :data-time="time"
                  :cpntId='"pac-ven-decisao-resposta--proximo--salvar"'
                  :cpntStatus='""' 
                  :cpntTexto='"Salvar"' 
                  :cpntClass="[ 'btn', 'btn-default' ]"

                  @onClickButton='pacVenSalvarMotivo'
                ></RF-Button>
              </div>
            </div>
          </template>
        </RF-Dialog>
      </div>
    </template>
  </RF-Dialog>
</template>

<style scoped>
  .aba-titulo {
    width: calc(100% + 20px);
    margin-left: -20px;
  }
    .aba-titulo > tr > td.passadores {
      width: 40px;
      text-align: center;
      padding-left: 25px;
      padding-right: 5px;
    }
      .aba-titulo > tr > td.passadores > span > svg {
        font-size: 25px;
        color: #525252;
        cursor: pointer;
      }
        .aba-titulo > tr > td.passadores > span > svg:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }

  .pagina-ini {
    text-align: center;
  }

  .pagina-pacotes {
    background: #e9e9e9;
    border: 1px solid #ccc;
    margin: 5px 0px;
    border-radius: 5px;
    padding: 5px 0px 5px 10px;
  }
  .pagina-pacotes > table {
    width: 100%;
  }
    .pagina-pacotes > table > tr > td > div > .adiar {
      margin: 3px 0px;
      font-size: 12px;
    }
      .pagina-pacotes > table > tr > td > div > .adiar > a {
        cursor: pointer;
      }
    .pagina-pacotes > table > tr > td.buttons > div {
      text-align: center;
      float: right;
      width: 130px;
    }
      .pagina-pacotes > table > tr > td.buttons > div > button {
        width: 100px;
        margin: 3px 0px;
      }
    
    .pagina-pacotes > table > tr > td.buttons > .valores {
      margin-bottom: 5px;
    }
      .pagina-pacotes > table > tr > td.buttons > .valores > span {
        font-size: 12px;
      }
      .pagina-pacotes > table > tr > td.buttons > .valores > span.valor {
        font-size: 18px;
      }

    .pagina-pacotes > table > tr > td {
      vertical-align: top;
    }
      .pagina-pacotes > table > tr > td.dados > .titulo {
        display: inline-block;
        font-weight: 600;
      }
        .pagina-pacotes > table > tr > td.dados > .titulo > svg {
          margin-right: 5px;
        }
        .pagina-pacotes > table > tr > td.dados > .titulo > span {
          font-size: 16px;
          padding-right: 5px;
          letter-spacing: 3px;
        }
        .pagina-pacotes > table > tr > td.dados > .titulo > hr {
          margin: 0px;
          border-top: 1px solid #999;
        }

      .pagina-pacotes > table > tr > td.dados > ul {
        margin-top: 15px;
        padding-left: 30px;
      }
        .pagina-pacotes > table > tr > td.dados > ul > li {
          margin: 8px 0px;
          text-align: justify;
          padding-right: 20px;
        }
    .fatura {
      width: 270px;
      background: #F9F9F9;
      border: 1px solid #ccc;
      padding: 8px;
      border-radius: 8px;
      float: right;
      margin-left: 15px;

      -webkit-box-shadow: 5px 5px 5px 0px rgba(133,133,133,0.4);
      -moz-box-shadow: 5px 5px 5px 0px rgba(133,133,133,0.4);
      box-shadow: 5px 5px 5px 0px rgba(133,133,133,0.4);
    }
      .fatura > table {
        width: 100%;
      }
        .fatura > table > tr > td {
          text-align: center;
          padding: 3px 0px;
          width: 50%;
        }
        .fatura > table > tr > td > hr {
          margin: 3px 0px;
          border-color: #ddd;
        }
        .fatura > table > tr.valores > td {
          text-align: right;
        }
        .fatura > table > tr.valores > td:last-child {
          padding-right: 10px;
        }
    .fatura-info {
      /* width: 270px; */
    }
      .fatura-info > .descricao {
        text-align: justify;
      }
        .fatura-info > .descricao > div{
          width: 100%;
          text-align: center;
        }
      .fatura-info > .campos {
        margin-top: 10px;
      }
</style>

<style>
  .fatura-info > .campos > div {
    display: inline-block;
  }
    .fatura-info > .campos > div > div > input {
      border: 1px solid #CCC;
      border-radius: 5px;
    }
  .fatura-info > .campos > button {
    margin-top: -3px;
    margin-left: 10px;
  }
</style>

<script>
  export default {
    props: {
      cpntPacoteIds: {
        default: function () {
          return null
        }
      },
      cpntFecharFormulario: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'RF-Explica': () => import('@/components/rf-geral/explica/RF-Explica.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: '',
        dados: null,
        pacotes: [],
        pagina: null,
        contratar: [],
        buttons: {},
        motivo: {},
        senha: {},
        confirma: {},
        valores: {}
      }
    },
    mounted: function () {
      this.pacVenIniciar()
    },
    methods: {
      pacVenIniciar: function () {
        // REMOVE O MENU E AS OUTRAS OPÇÕES ATRAS
        // this.$store.commit('SET_TELA_APRESENTA', [{ chave: 'menu', value: false }, { chave: 'mascara', value: false }, { chave: 'conteudo', value: true }])

        // SETA A PGINA ATUALIZADA
        this.pagina = 0

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // SETA O STATUS DA TELA
        this.pacVenSetaStatusGeral('carregando')

        // CHAMA A FUNÇÃO PARA CARREGAR OS DADOS DOS PACOTES
        this.pacVenBuscarPacotes()
      },
      pacVenFechar: function (atualizar, apiSuccess = null) {
        // IMPORTA A FUNÇÃO PARA INICIAR AS VERIFICAÇÕES DA SESSÃO
        const SESSAO_ALTERAR_PAC_VENCIDOS = require('@/assets/js/Sessao.js').SESSAO_ALTERAR_PAC_VENCIDOS

        // CHAMA A FUNÇAO PARA LIMPAR O STATUS DE PACOTE VENCIDO
        SESSAO_ALTERAR_PAC_VENCIDOS(this.$store.state.token.conta).then(() => {
          switch (atualizar) {
            case true: {
              // IMPORTA A FUNÇÃO PARA INICIAR AS VERIFICAÇÕES DA SESÃO
              const SESSAO_ATUALIZAR_TOKEN = require('@/assets/js/Sessao.js').SESSAO_ATUALIZAR_TOKEN
    
              // CHAMA A FUNÇÃO PARA RENOVAR O TOKEN
              SESSAO_ATUALIZAR_TOKEN('clu_pcc', () => {
                // REDIRECIONA PARA PAGINA INICIAL
                if (this.$route.name === 'pacotes_vencidos') {
                  this.$router.push({ name: 'pag_inicial', params: { cts: this.$store.state.token.cts } })
                } else {
                  location.reload()
                }
    
                // APRESENTA A MENSAGEM RETORNADA DA API
                if (apiSuccess !== null) {
                  this.$store.state.TRATAR_RET_LOT_API(apiSuccess)
                }
              })
              break
            }

            default: {
              // REDIRECIONA PARA PAGINA INICIAL
              if (this.cpntFecharFormulario !== null) {
                this.cpntFecharFormulario(atualizar)
              } else {
                this.$router.push({ name: 'pag_inicial', params: { cts: this.$store.state.token.cts } })
              }

              // APRESENTA A MENSAGEM RETORNADA DA API
              if (apiSuccess !== null) {
                self.$store.state.TRATAR_RET_LOT_API(apiSuccess)
              }
              break
            }
          }
        })
      },
      pacVenSetaStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      pacVenAlterarButtons: function (id) {
        // PEGA OS DADOS DO BUTTON CLICADO
        var index = id.split('--')

        // SETA A DECISÃO FEITA PELO USUARIO
        this.contratar[index[2]].decisao = (this.contratar[index[2]].decisao === index) ? '' : index[1]
        
        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      pacVenBuscarPacotes: function () {
        var self = this

        // FAZ A BUSCA DOS PACOTES
        self.$store.state.comunicaAPI('/subase/pacote/get', 'GET', null, function (apiSuccess) {
          // SETA OS DADOS RECEBIDOS
          self.dados = apiSuccess

          // FAZ A FORMATAÇÃO DO CAMPO
          self.dados._valor_cnpj_adicional = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.dados.valor_cnpj_adicional)
          self.dados._valor_sin_clu_adicional = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.dados.valor_sin_clu_adicional)

          // SETA OS PACOTES RECEBIDOS
          self.pacotes = apiSuccess.data

          // SETA OS PACOTES QUE TEM QUE CONTRATAR
          self.contratar = apiSuccess.data.filter(item => [ 't' ].indexOf(item.contratado) !== -1)

          // VERIFICA OS IDS DOS PACOTES
          if (self.cpntPacoteIds !== null) {
            self.contratar = self.contratar.filter(item => self.cpntPacoteIds.indexOf(Number(item.pac_id)) !== -1)
          }

          if (self.contratar.length >= 1) {
            // CONVERTE OS CAMPOS INFORMADOS
            for (var linha in self.contratar) {
              // SETA A VARIAVEL PARA MOSTRAR O DETALHE
              self.contratar[linha]._detalhe = false

              for (var coluna in self.contratar[linha]) {
                switch (coluna) {
                  case 'j_pac_desc':
                    self.contratar[linha]['_' + coluna] = JSON.parse(self.contratar[linha][coluna])
                    break
  
                  case 'ti_valor':
                  case 'lu_valor':
                  case 'bilhetagem_valor':
                    self.contratar[linha]['_' + coluna] = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.contratar[linha][coluna])
                    break
                }
              }
              
              // INICIA O VALOR DA DECISÃO DO CAMPO
              self.contratar[linha].decisao = ''
  
              // INICIA O CAMPO QUE VAI RECEBER O MOTIVO
              self.contratar[linha].motivo = ''
  
              // CONVERTE PARA NUMERO O VALOR RECEBIDO
              self.contratar[linha].faltam_n_dias = Number(self.contratar[linha].faltam_n_dias)
  
              // SETA A COR DA LINHA
              if (self.contratar[linha].faltam_n_dias <= 0) {
                self.contratar[linha].cor = 'vermelho'
              } else if (self.contratar[linha].faltam_n_dias <= 5) {
                self.contratar[linha].cor = 'amarelo'
              } else {
                self.contratar[linha].cor = 'verde'
              }
            }
            
            // SETA O STATUS DA TELA
            // self.pacVenSetaStatusGeral('')
            self.pacVenFinalizarContratacao()
          } else {
            self.pacVenFechar(false)
          }
        }, self.pacVenSetaStatusGeral)
      },
      pacVenSalvarMotivo: function () {
        // PEGA O INDEX DO PACOTE
        var indexP = this.motivo.indexP

        // INICIA O CAMPO QUE VAI RECEBER O MOTIVO
        this.contratar[indexP].motivo = this.motivo.value

        // LIMPA OS DADOS DO CAMPO MOTIVO 
        this.motivo = {}

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()

        // CHAMA A FUNÇÃO PARA ALTERAR A PAGINA
        this.pacVenAlterarPagina('pac-ven-decisao-resposta--proxima')
      },
      pacVenResponderPergunta: function (id, indexP) {
        var self = this

        // PEGA OS DADOS DO BUTTON CLICADO
        var index = id.split('--')

        // SETA A OPÇÃO ESCOLHIDA PELO USUARIO
        self.contratar[indexP].decisao = index[2]

        switch (self.contratar[indexP].decisao) {
          case '':
            break

          case 'n':
            self.motivo = {
              indexP: indexP,
              status: '',
              tamanho: 1,
              maxLength: 500,
              tipo: 'textarea',
              id: 'pac-ven-decisao-resposta--proxima--motivo',
              nome: 'O que você achou do pacote <b>' + self.contratar[indexP].pac_nome + '</b>?',
              value: '',
              config: {
                removeButtons: 'Save,NewPage,Preview,Print,Templates,About,ShowBlocks,Cut,Copy,Paste,PasteText,PasteFromWord,Undo,Redo,Find,Replace,SelectAll,Scayt,Form,Checkbox,Radio,TextField,Textarea,Select,Button,ImageButton,HiddenField,CopyFormatting,Subscript,Superscript,Blockquote,CreateDiv,Outdent,Indent,BidiLtr,BidiRtl,Language,Anchor,Image,Flash,Table,HorizontalRule,Smiley,SpecialChar,PageBreak,Iframe,Styles,Format',
                toolbarGroups: [
                  { name: 'tools', groups: [ 'tools' ] },
                  { name: 'document', groups: [ 'mode', 'document', 'doctools' ] },
                  { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                  { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                  { name: 'forms', groups: [ 'forms' ] },
                  { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                  { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph' ] },
                  { name: 'links', groups: [ 'links' ] },
                  { name: 'insert', groups: [ 'insert' ] },
                  { name: 'styles', groups: [ 'styles' ] },
                  { name: 'colors', groups: [ 'colors' ] },
                  { name: 'others', groups: [ 'others' ] },
                  { name: 'about', groups: [ 'about' ] }
                ],
                height: '100'
              },
              onFecharDialog: self.pacVenSalvarMotivo,
              onChange: function (value) {
                // SETA O VALOR RECEBIDO
                self.motivo.value = value

                // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
                self.time = new Date().getTime()
              }
            }

            // SETA O FOCUS NO CAMPO INFORMADO
            self.pacVenRealizarFocusCampos(self.motivo.id)
            break

          default:
            // LIMPA OS DADOS DO CAMPO MOTIVO 
            self.motivo = {}

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()

            // CHAMA A FUNÇÃO PARA ALTERAR A PAGINA
            self.pacVenAlterarPagina('pac-ven-decisao-resposta--proxima', indexP)
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()
      },
      pacVenConfirmarAlteracao: function () {
        var self = this

        // SETA O STATUS DO BUTOTN
        self.confirma.status = 'carregando'

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // INICIA O FORMULARIO QUE SERÁ ENVIADO PARA API
        var formData = { lot: [] }

        for (var key in self.contratar) {
          if ([ 's', 'n' ].indexOf(self.contratar[key].decisao) !== -1) {
            var pacote = {}

            // SETA A DECISÃO
            pacote.decisao = self.contratar[key].decisao

            // SETA O MOTIVO
            pacote.motivo = self.contratar[key].motivo

            // SETA O CODIGO DO PACOTE
            pacote.id = self.contratar[key].pac_id

            // SETA A SENHA DO USUARIO
            pacote.senha = self.senha.value

            // ADICIONA O VALOR ENCONTRADO AO VETOR DA API
            formData.lot.push(pacote)
          }
        }

        // VERIFICA SE TEM PACOTE PARA ATUALIZAR
        if (formData.lot.length === 0) {
          // APRESENTA A MENSAGEM DE ERRO
          self.$store.state.msgWarn('WEB [406]: Marque uma opção antes de continuar.', 'warning')

          // SETA O STATUS DO BUTOTN
          self.confirma.status = ''

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          self.time = new Date().getTime()
        } else {
          self.$store.state.comunicaAPI('/config/pacote/decidir', 'PUT', formData, function (apiSuccess) {
            // VERIFICA SE DEVE ATUALIZAR A TELA
            var atualizar = apiSuccess.lot === undefined ? true : apiSuccess.lot.filter(item => item.code === '200').length >= 1

            // TRATA O RETORNO RECEBIDO
            self.$store.state.TRATAR_RET_LOT_API(apiSuccess, () => { self.pacVenFechar(atualizar, apiSuccess) })
          }, self.pacVenSetaStatusGeral, function (apiValid, apiStatus) {
            self.$store.state.FUN_API_RET_VALIDA(self, 'formulario', apiValid, apiStatus, {}, true, function () {
              // SETA O STATUS DO BUTOTN
              self.confirma.status = ''
  
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              self.time = new Date().getTime()
            })
          })
        }
      },
      pacVenAlterarPagina: function (id, indexP) {        
        // PEGA OS DADOS DO BUTTON CLICADO
        var index = id.split('--')[1]

        // INICIA A ACAO QUE DEVE FAZER
        var acao = ''

        // INICIA A PROXIMA PAGINA
        var pagNova = ''

        // VERIFICA A AÇÃO QUE DEVE FAZER
        if (index === 'proxima') {
          acao = 'proxima'
          index = [ 'ini' ].indexOf(this.pagina) !== -1 ? 0 : this.pagina + 1
        } else if (index === 'voltar') {
          acao = 'voltar'
          index = [ 'fim' ].indexOf(this.pagina) !== -1 ? this.contratar.length - 1 : this.pagina - 1
        }

        if (acao === 'voltar' || [ 'ini', 'fim' ].indexOf(this.pagina) !== -1 || [ 'a', 'n', 's' ].indexOf(this.contratar[indexP].decisao) !== -1) {         
          switch (index) {
            case 'ini':
              pagNova = 0
              break
  
            default:
              pagNova = Number(index)
              break
          }
  
          // VERIFICA SE PASSOU POR TODOS OS PACOTES
          if (pagNova >= this.contratar.length) {
            // VERIFICA SE FOI ADIADO TODOS OS PACOTES
            if (this.contratar.filter(item => item.decisao === 'a').length === this.contratar.length) {
              this.pacVenFechar(false)
            } else {
              this.pacVenFinalizarContratacao()
            }
          } else {
            // SETA A PGINA ATUALIZADA
            this.pagina = pagNova
    
            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }
        // } else {
        //   this.$store.state.msgWarn('WEB [406]: Marque uma opção antes de continuar.', 'warning')
        }
      },
      pacVenFinalizarContratacao: function () {
        var self = this

        // SETA O STATUS DA TELA
        self.pacVenSetaStatusGeral('carregando')

        // SETA A PGINA ATUALIZADA
        self.pagina = 'fim'

        // INICIA OS VALORES TOTAIS
        self.valores = { total: 0, ti_valor: 0 }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        self.time = new Date().getTime()

        // SETA A VARIAVEL PARA ZERAR O VALOR
        var zerar = []

        // CALCULA O NOVO VALOR DA FATURA
        for (var index in self.contratar) {
          switch(self.contratar[index].decisao) {
            case 's':
              if ([ '30' ].indexOf(self.contratar[index].pac_id) !== -1) {
                // // CALCULA O VALOR
                // self.contratar[index].lu_valor = (Number((self.dados.virtual_arm_arquivo_qtde_gb * (self.dados.virtual_arm_arquivo_valor_por_gb / 100)).toFixed(2)) * 100).toString()

                // // FORMATA O VALOR DO PACOTE
                // self.contratar[index]._lu_valor = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.contratar[index].lu_valor)

                // // SOMA NO VALOR TOTAL
                // self.valores.total += Number(self.contratar[index].lu_valor)
              } else if ([ '36' ].indexOf(self.contratar[index].pac_id) !== -1) {
                // // CALCULA O VALOR
                // self.contratar[index].lu_valor = (Number(self.dados.virtual_n_cnpj_adicional) * Number(self.dados.valor_cnpj_adicional)).toString()

                // // FORMATA O VALOR DO PACOTE
                // self.contratar[index]._lu_valor = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.contratar[index].lu_valor)

                // // SOMA NO VALOR TOTAL
                // self.valores.total += Number(self.contratar[index].lu_valor)
              } else if ([ '37' ].indexOf(self.contratar[index].pac_id) !== -1) {
                // // CALCULA O VALOR
                // self.contratar[index].lu_valor = (Number(self.dados.virtual_sincronizar_qtde) * Number(self.dados.valor_sin_clu_adicional)).toString()

                // // FORMATA O VALOR DO PACOTE
                // self.contratar[index]._lu_valor = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.contratar[index].lu_valor)

                // // SOMA NO VALOR TOTAL
                // self.valores.total += Number(self.contratar[index].lu_valor)
              } else if ([ '30' ].indexOf(self.contratar[index].pac_id) === -1) {
                // self.valores.total += Number(self.contratar[index].lu_valor)
              } else {
                zerar.push(self.contratar[index].pac_id)
              }

              if ([ '', null, undefined ].indexOf(self.contratar[index].ti_valor) === -1) {
                self.valores.ti_valor += Number(self.contratar[index].ti_valor)
              }
              break
          }
        }

        // SETA O VALOR ATUAL TOTAL CALCULADO
        self.valores._total = (zerar.length === self.contratar.length ? '---' : self.$store.state.FUN_MASK_VALOR('valorMoeda', self.valores.total))
        self.valores._ti_valor = self.$store.state.FUN_MASK_VALOR('valorMoeda', self.valores.ti_valor)

        // SETA OS DADOS DO CAMPO SENHA 
        self.senha = {
          tamanho: 57,
          status: '',
          id: 'pac-ven-decisao-resposta--senha',
          tipo: 'input',
          type: 'password',
          value: '',
          onChange: function (value) {
            // SETA O VALOR RECEBIDO
            self.senha.value = value

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            self.time = new Date().getTime()
          }
        }

        self.confirma = {
          status: '',
          id: 'pac-ven-decisao-resposta--proximo--s',
          texto: 'Confirmar',
          class: [ 'btn', 'btn-primary', 'btn-sm' ],
          onClick: self.pacVenConfirmarAlteracao
        }

        // SETA O FOCUS NO CAMPO INFORMADO
        self.pacVenRealizarFocusCampos(self.senha.id)

        // SETA O STATUS DA TELA
        self.pacVenSetaStatusGeral('')
      },
      pacVenRealizarFocusCampos: function (campo, tentativa = 0) {
        if ([ '', null, undefined ].indexOf(campo) === -1) {
          var self = this

          setTimeout(function () {
            if ([ '', null, undefined ].indexOf(self.$refs[campo]) === -1 && [ '', null, undefined ].indexOf(self.$refs[campo].$refs) === -1 && Object.keys(self.$refs[campo].$refs).length === 1 && [ '', null, undefined ].indexOf(self.$refs[campo].$refs[Object.keys(self.$refs[campo].$refs)[0]].onFocusField) === -1) {
              self.$refs[campo].$refs[Object.keys(self.$refs[campo].$refs)[0]].onFocusField()
            } else if (tentativa <= 10) {
              self.pacVenRealizarFocusCampos(campo, (tentativa + 1))
            }
          }, (tentativa === 0 ? 0 : 200))
        }
      },
      pacVenAlterarDetalhe: function (indexC) {
        // SETA O VALOR DO DETALHE
        this.contratar[indexC]._detalhe = !this.contratar[indexC]._detalhe

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    }
  }
</script>
